/**
 * 尾程报价管理前端接口
 */

import { request } from '@/utils/http'
import { type BatchDeleteRequest, type PageResponse } from '@/api/types/common'
import {
  type InitiateConsultationRequest, type InqQuotPriceChargingItemVO,
  type ShokzQuotationBaseModel, type ShokzQuotationBatchSubmitRequest, type ShokzQuotationChargingItemVO,
  type ShokzQuotationPageRequest,
  type ShokzQuotationSaveRequest
} from './quotation-base'

/**
 * 尾程报价模型（继承基础报价模型）
 */
export interface ShokzQuotationLastMileModel extends ShokzQuotationBaseModel {
}

/**
 * 尾程报价分页查询请求参数
 */
export interface ShokzQuotationLastMilePageRequest extends ShokzQuotationPageRequest {
}

/**
 * 尾程报价保存请求参数
 */
export interface ShokzQuotationLastMileSaveRequest extends ShokzQuotationSaveRequest {
}

/**
 * 分页查询尾程报价列表
 */
export const pageQuotationLastMile = (params: ShokzQuotationLastMilePageRequest) => {
  return request.post<PageResponse<ShokzQuotationLastMileModel>>('/price/shokzQuotation/last-mile/page', params)
}

/**
 * 根据ID获取尾程报价详情
 */
export const getQuotationLastMileById = (id: string) => {
  // 提取纯数字ID部分，去除可能的额外信息
  const pureId = id.split(/\s+/)[0];
  return request.post<ShokzQuotationLastMileModel>('/price/shokzQuotation/last-mile/get', { id: pureId })
}

/**
 * 根据询价编号获取尾程报价详情
 */
export const getQuotationLastMileByInquiryNo = (inquiryNo: string) => {
  return request.post<ShokzQuotationLastMileModel>('/price/shokzQuotation/last-mile/get', { inquiryNo })
}

/**
 * 新增尾程报价
 */
export const saveQuotationLastMile = (params: ShokzQuotationLastMileSaveRequest) => {
  return request.post<boolean>('/price/shokzQuotation/last-mile/save', params)
}

export const queryQuotationLastMileByInquiry = (params: { inquiryId?: string | number; inquiryNo?: string }) => {
  return request.post<ShokzQuotationLastMileModel[]>('/price/shokzQuotation/last-mile/queryByInquiry', params)
}

export const createQuotationLastMileScheme = (quotationId: string | number) => {
  return request.post<string | number>(`/price/shokzQuotation/last-mile/createScheme/${quotationId}`)
}

/**
 * 修改尾程报价
 */
export const updateQuotationLastMile = (params: ShokzQuotationLastMileSaveRequest) => {
  return request.post<boolean>('/price/shokzQuotation/last-mile/update', params)
}

/**
 * 批量提交尾程报价方案
 */
export const batchSubmitQuotationLastMile = (params: ShokzQuotationBatchSubmitRequest<ShokzQuotationLastMileSaveRequest>) => {
  return request.post<boolean>('/price/shokzQuotation/last-mile/batchSubmit', params)
}

export const validateQuotationTokenLastMile = (token: string, quotationId: string, tenantId: string) => {
  return request.post<boolean>('/price/shokzQuotation/last-mile/validateToken', { token, quotationId, tenantId })
}

/**
 * 批量删除尾程报价
 */
export const batchDeleteQuotationLastMile = (params: BatchDeleteRequest) => {
  return request.post<boolean>('/price/shokzQuotation/last-mile/batch-delete', params)
}

/**
 * 发起新磋商
 * 针对指定的整箱报价单发起新的磋商记录,更新报价单磋商状态为"磋商中"
 */
export const initiateConsultationLastMile = (params: InitiateConsultationRequest) => {
  return request.post<boolean>('/price/shokzQuotation/last-mile/initiateConsultation', params)
}

/**
 * 商户报价单加价保存
 */
export const businessQuotationMarkupLastMile = (params: InqQuotPriceChargingItemVO) => {
  return request.post<InqQuotPriceChargingItemVO>('/price/shokzQuotation/last-mile/businessQuotationMarkup', params)
}

/**
 * 供应商报价单加价保存
 */
export const supplierQuotationMarkupLastMile = (params: ShokzQuotationChargingItemVO) => {
  return request.post<ShokzQuotationChargingItemVO>('/price/shokzQuotation/last-mile/supplierQuotationMarkup', params)
}
